"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSessionParams = void 0;
function getSessionParams() {
    var _a;
    try {
        var contextString = (_a = sessionStorage.getItem('landingContext')) !== null && _a !== void 0 ? _a : 'false';
        var context = JSON.parse(contextString);
        if (context) {
            return context;
        }
        else {
            return {
                landingPath: null,
                landingQuery: null,
                landingTags: []
            };
        }
    }
    catch (err) {
        console.error(err);
    }
}
exports.getSessionParams = getSessionParams;
